<template>
  <!-- 出発地選択UI -->
  <div class="field">
    <label>{{ label }}</label>
    <div class="select-wrap">
      <select
        v-model="selectedBusStop"
        class="form-control"
        @change="setBusStop(selectedBusStop)"
      >
        <option selected :value="{ name: null, id: null }">
          {{ label }}を選択してください
        </option>
        <option
          v-for="(busStop, index) in busStops"
          :key="index"
          :value="busStop"
        >
          {{ busStop.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { useVModel } from "vue-composable";

export default {
  name: "SelectBusStop",
  props: {
    selectedBusStop: {
      type: Object,
      required: true,
    },
    busStops: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    setBusStop: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const selectedBusStop = useVModel(props, "selectedBusStop");
    return {
      selectedBusStop,
    };
  },
};
</script>

<style lang="scss" scoped>
.field {
  position: relative;
  margin: auto;
  width: 95%;
  padding-bottom: 6px;
}

.field label {
  position: absolute;
  width: 50px !important;
  z-index: 100;
  top: 0;
  margin-top: 13px;
  margin-left: 15px;
  font-size: 13px;
  color: #888888;
}

/* セレクトボックス */

select {
  width: 100%;
  height: 40px;
  margin-bottom: 0;
  border: 1px solid black;
  border-radius: 5px;
  background-color: white;
  outline: none;
  padding: 10px 5px;
  /* font-size: 16px; */
  line-height: 20px;
  font-weight: bold;
  color: #000000;
  padding-left: 80px;
  font-size: 16px;
  -webkit-appearance: none;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 0;
}

.select-wrap::after {
  content: "";
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #000000;
  border-right: solid 2px #000000;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  right: 15px;
  margin-top: -6px;
}
</style>
